import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(with-global-style)/privacy/desktop_page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(with-global-style)/privacy/mobile_page.tsx");
